export default class SendEmailToVerifyUserError extends Error {}
